import React,{forwardRef} from 'react'
import ServiceForm from './ServiceForm'
const AddService = forwardRef((props, ref) => {
    const {
        formValidateError, 
        serviceFormSave, 
        updateServiceList,
        formData,
        isButtonLoader
    } = props;
    return (
        <>
            <ServiceForm
                formData={formData}
                formValidateError={formValidateError}
                serviceFormSave={serviceFormSave}
                updateServiceList={updateServiceList}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})

export default AddService